<template>
    <div class="container full-width">
        <div class="text-subtitle1">Comments to shoppers</div>
        <q-input
            :value="text"
            @input="onChange"
            class="bg-white"
            placeholder="Enter comment to shopper/rider"
            dense
            outlined
        />
    </div>
</template>

<script>
export default {
    name: "CommendToShoppers",
    computed: {
        text(){
            return this.$store.state["checkout"]["specialComment"];
        }
    },
    methods: {
        onChange(text){
            this.$store.commit("checkout/setSpecialComment", text);
        }
    }
};
</script>

<style scoped>
.container {
    padding: 0px 8px;
}
</style>
